export * from './lib/custom-attribute-input.component.module';
export { CustomAttributeInputComponent } from './lib/custom-attribute-input.component';
